import * as React from 'react';
import classnames from 'classnames';
import { UnitPrice, BestPrice } from '@grandvisionhq/common';
import { ProductDetailPrice, PriceDisclaimerContainer } from '@grandvisionhq/fun-products';
import { ProductDiscountBadge } from '@grandvisionhq/lib-visuals';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';

const PDPPriceSection = ({ originalPrice , discountedPrice , discountDescription , discountBadge , unitPrice , bestPrice , className  })=>{
    const { getLabel , currency  } = useIntl();
    const { isBestPriceEnabled , isPricePerUnitEnabled , featureConfigs: { unitPriceFixedDecimalsConfig  } = {} ,  } = useFeatureToggles();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('pdp-price-section', className),
        role: "group",
        "aria-label": getLabel('products.screenreader.priceInformation'),
        "data-t": "price-section"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "pdp-price-section__price-row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "price-section__price-wrapper"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: originalPrice,
        discountedPrice: discountedPrice,
        currency: currency
    })), isPricePerUnitEnabled && unitPrice && /*#__PURE__*/ React.createElement(UnitPrice, {
        amount: unitPrice,
        currencyCode: currency,
        fixedDecimals: unitPriceFixedDecimalsConfig === null || unitPriceFixedDecimalsConfig === void 0 ? void 0 : unitPriceFixedDecimalsConfig.pdp,
        isCentAmount: true
    })), discountBadge && /*#__PURE__*/ React.createElement(ProductDiscountBadge, {
        className: "pdp-price-section__discount",
        label: discountDescription,
        discount: discountBadge,
        isWide: true
    }), /*#__PURE__*/ React.createElement(PriceDisclaimerContainer, null), /*#__PURE__*/ React.createElement(BestPrice, {
        isFeatureEnabled: isBestPriceEnabled,
        bestPriceAmount: bestPrice,
        isCentAmount: true,
        currencyCode: currency,
        discountedPrice: discountedPrice,
        originalPrice: originalPrice
    }));
};

export { PDPPriceSection };
//# sourceMappingURL=PDPPriceSection.js.map
